export const getUserId = (state) => state.mainApp.userId;
